import { map, finalize } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { DataServiceBase } from '../../../core/service/base/data.service.base';
import { PagedResult } from '../../../core/model/paged-result';
import { LogRecord } from '../../../common/model/log-record';

@Injectable()
export class InvoiceLogService extends DataServiceBase {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, messageService, progressBar, config, 'invoice-log');
  }

  getPagedList(contactId: string, page: number, pageSize: number): Observable<PagedResult<LogRecord>> {
    this.progressBar.start();
    return this.client
      .post<PagedResult<LogRecord>>(`${this.endpoint}/page`, {
        page: page,
        pageSize: pageSize,
        filter: { entityId: contactId },
      })
      .pipe(
        map(response => {
          let result = Object.assign(new PagedResult(), response);
          result.items = response.items.map(i => new LogRecord(i));
          return result;
        }),
        finalize(() => this.progressBar.stop())
      );
  }
}
